/**
 * MovesNFLComponent - Componente para mostrar información de la última jugada en NFL
 * 
 * Renderiza los datos del último movimiento incluyendo down, distancia y línea de yardas
 * Solo muestra la información si los datos están disponibles
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Object} props.item - Datos del juego de NFL
 * @param {Object} props.item.football_data - Datos específicos del fútbol americano
 * @param {Object} props.item.football_data.last_move - Información del último movimiento
 * @param {string} props.item.football_data.last_move.down - Número de down actual
 * @param {string} props.item.football_data.last_move.distance - Distancia a recorrer
 * @param {string} props.item.football_data.last_move.yardLine - Línea de yardas actual
 * 
 * @returns {JSX.Element} Componente con información de la última jugada
 * 
 * @example
 * <MovesNFLComponent 
 *   item={{
 *     football_data: {
 *       last_move: {
 *         down: "3rd",
 *         distance: "7",
 *         yardLine: "NYG 25"
 *       }
 *     }
 *   }}
 * />
 */
export default function MovesNFLComponent({ item }) {
  const { football_data } = item;
  const { last_move } = football_data;

  return (
    <div className="moves-nfl">
      {last_move?.down && last_move?.distance && (
        <p className="moves-down">{last_move.down} y {last_move.distance}</p>
      )}
      {last_move?.yardLine && <p className="moves-yard">{last_move?.yardLine}</p>}
    </div>
  );
}